import { parse, isValid } from 'date-fns';

export function convertDate(date: string, isPreview: boolean): string {
  let inputDate: Date;
  const customFormat = 'EEE, MMMM do, HH:mm'; // Support bulba custom format, e.g. "Tue, July 18th, 09:36"
  inputDate = parse(date, customFormat, new Date());

  if (!isValid(inputDate)) {
    inputDate = new Date(date);
  }
  const options: Intl.DateTimeFormatOptions = {
    ...(isPreview && { year: '2-digit' }),
    ...(!isPreview && { weekday: 'short' }),
    month: isPreview ? '2-digit' : 'short',
    day: isPreview ? '2-digit' : 'numeric',
    ...(!isPreview && { hour: 'numeric' }),
    ...(!isPreview && { minute: '2-digit' }),
    ...(!isPreview && { hour12: false }),
  };
  return inputDate.toLocaleDateString('en-US', options);
}
